var map = {
	"./404-robot.svg": 47317,
	"./app-download.svg": 52288,
	"./app-gallery.svg": 56106,
	"./app-store.svg": 94699,
	"./apple-podcast.svg": 99113,
	"./apple.svg": 87854,
	"./arrow-circle-right.svg": 74223,
	"./arrow-down-red.svg": 66732,
	"./arrow-down.svg": 20566,
	"./arrow-up.svg": 68685,
	"./arrow.svg": 31449,
	"./banana.svg": 96993,
	"./bng-flag.svg": 71380,
	"./bread-crum-separator.svg": 64478,
	"./british-flag.svg": 85314,
	"./cherry.svg": 50653,
	"./close-icon.svg": 83464,
	"./close.svg": 70862,
	"./daily-crossword.svg": 81674,
	"./double-arrow.svg": 53981,
	"./edit.svg": 67654,
	"./egypt-flag.svg": 8414,
	"./eid.svg": 85580,
	"./facebook.svg": 43254,
	"./file-attachment.svg": 68686,
	"./follow.svg": 20129,
	"./gears.svg": 76594,
	"./gn-reach-icon.svg": 56531,
	"./google-play.svg": 9902,
	"./google.svg": 4087,
	"./green-up-arrow.svg": 21671,
	"./hamburger-facebook.svg": 11912,
	"./hamburger-instagram.svg": 46352,
	"./hamburger-linkedin.svg": 39834,
	"./hamburger-spotify.svg": 66786,
	"./hamburger-telegram.svg": 19173,
	"./hamburger-twitter.svg": 63705,
	"./hamburger-whatsapp.svg": 61014,
	"./hamburger-youtube.svg": 1007,
	"./hamburger.svg": 20795,
	"./how-to-play.svg": 63441,
	"./humidity.svg": 32993,
	"./image-gallery.svg": 82604,
	"./india-flag.svg": 98858,
	"./instagram.svg": 38674,
	"./linkedin.svg": 3380,
	"./live.svg": 18596,
	"./loading.svg": 39702,
	"./login.svg": 95089,
	"./logo-small.svg": 26897,
	"./logo.svg": 9155,
	"./logout.svg": 42624,
	"./lulu-money.svg": 78433,
	"./mail.svg": 25119,
	"./mast-logo.svg": 69019,
	"./nepal-flag.svg": 76835,
	"./new-label.svg": 96445,
	"./offer-menu-right-arrow.svg": 9437,
	"./pak-flag.svg": 23177,
	"./philp-flag.svg": 11802,
	"./phone.svg": 79746,
	"./photo.svg": 24378,
	"./pinterest.svg": 19080,
	"./play-arrow.svg": 46844,
	"./play-games.svg": 61646,
	"./podcast.svg": 90422,
	"./point-arrow.svg": 98076,
	"./portrait.svg": 31695,
	"./premium.svg": 95533,
	"./print.svg": 23275,
	"./profile.svg": 58425,
	"./recipe-share-mail.svg": 9554,
	"./recipe-share-menu.svg": 28622,
	"./right-arrow-new.svg": 63357,
	"./search-gray-color.svg": 67468,
	"./search.svg": 84626,
	"./share-facebook.svg": 452,
	"./share-google.svg": 78717,
	"./share-instagram.svg": 63028,
	"./share-link.svg": 99520,
	"./share-linkedin.svg": 69758,
	"./share-mail.svg": 97861,
	"./share-menu.svg": 7621,
	"./share-pintrest.svg": 81569,
	"./share-telegram.svg": 73121,
	"./share-whatsapp.svg": 85778,
	"./share-x.svg": 66936,
	"./share-youtube.svg": 2379,
	"./slider-left-arrow.svg": 40905,
	"./slider-right-arrow.svg": 39860,
	"./spell-it.svg": 57926,
	"./spotify-color-icon.svg": 66356,
	"./spotify.svg": 76072,
	"./sri-lanka-flag.svg": 52659,
	"./strawberry.svg": 9189,
	"./sudoku.svg": 76469,
	"./telegram.svg": 71939,
	"./tips.svg": 74188,
	"./toast-error.svg": 19206,
	"./toast-info.svg": 31040,
	"./tomato.svg": 53080,
	"./trending.svg": 93597,
	"./user-icon.svg": 34487,
	"./user.svg": 18595,
	"./video-play-btn.svg": 7093,
	"./video.svg": 20959,
	"./visibility.svg": 81794,
	"./whatsapp.svg": 27508,
	"./wind-speed.svg": 22954,
	"./word-search.svg": 90987,
	"./x.svg": 65606,
	"./youtube-color-icon.svg": 50019,
	"./youtube.svg": 96937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61139;